<template>
<div>
<section class="content-tlist">
<table class="content-table">
  <thead>
    <tr>
      <td>Role Group</td>
      <td>Actions</td>
    </tr>
  </thead>
  <tbody>
    <tr v-for="role in roles">
      <td>{{ role.name }}</td>
      <td>
        <a class="btn btn-secondary" href="" @click.prevent="editRole(role)">Edit</a>
        <a class="btn btn-danger" href="" @click.prevent="deleteRole(role)">Delete</a>
      </td>
    </tr>
  </tbody>
</table>
</section>
<a class="btn btn-primary" href="" @click.prevent="newRole()">New Role Group</a>
<rolegroup-edit v-if="currentRole" :role="currentRole" />
</div>
</template>

<script>
export default {
  data: ()=>({
    roles: [],
    currentRole: null,
  }),
  methods: {
    async loadRoles() {
      this.roles=(await api.list("RoleGroup")).items;
    },
    editRole(role) {
      this.currentRole=role;
    },
    deleteRole(role) {
    },
    newRole() {
      this.currentRole={
        name: "",
        perms: [],
      };
    },
  },
  mounted() {
    this.loadRoles();
  },
}
</script>
